var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('div',{staticClass:"o-grid o-grid--no-gutter"},[_vm._m(0),_c('div',{staticClass:"o-grid__cell top-buttons"},[_c('bos-button',{on:{"click":_vm.newFairWall}},[_vm._v("Neue Messe")])],1)]),_c('bos-overview-table',{attrs:{"data":_vm.fairWallEntries,"columns":[
        {
          key: 'displayName',
          name: 'Name'
        }
      ],"deleteTitle":"Interessante Messe löschen","deleteText":obj =>
          'Soll die Messe <b>"' +
          obj.displayName +
          '"</b> wirklich gelöscht werden?',"onEdit":_vm.editFairWall,"onDelete":_vm.deleteFairWall}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-grid__cell"},[_c('h2',[_vm._v("Interessante Messen")])])
}]

export { render, staticRenderFns }